import { useEffect, useState, useMemo } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { postRequest } from 'src/services';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { endpoints } from 'src/utils/axios';
import Iconify from 'src/components/iconify';
import { handleErrorMessages } from 'src/pages/components/errorhanling-formating';
import { useParams } from 'react-router';

export const EquipmentsCreateListModal = ({ open, onClose, reload, currentItem, closeform, }) => {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const { id } = useParams()
    const [ loading, setLoading ] = useState(false);

    const NewDocumentSchema = Yup.object().shape({
        // CSI_code: Yup.string().required('Name is required'),
        // description: Yup.string().required('Description is required'),
        // file: Yup.array().min(1, 'Images is required'),
    });

    const defaultValues = useMemo(
        () => ({
            file: currentItem?.file || 'None',
        }),
        [ currentItem ]
    );

    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });

    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [ currentItem, reset, defaultValues ]);

    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('CSI_code', data.CSI_code);
        formData.append('equipment_code', data.equipment_code);
        formData.append('name', data.name);
        formData.append('quantity', data.quantity);
        formData.append('unit_price', data.unit_price);
        formData.append('unit', data.unit);
        formData.append('hours', data.hours);
        formData.append('odometer_reading', data.odometer_reading);
        formData.append('own_cost', data.own_cost);
        formData.append('rental_cost', data.rental_cost);
        formData.append('operating_cost', data.operating_cost);
        formData.append('cost_type', data.cost_type);
        try {
            const response = await postRequest(
                `${endpoints.admin_dashboard.teachnical_database.equipments_categories.show_list_create}/${id}/equipments`,
                // currentItem?.id
                //  `${endpoints.accounting.documents.post_request}/${currentItem.id}?_method=PUT`
                formData,
                true
            );
            if (response.metadata?.success) {
                reset();
                onClose();
                reload();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });

    return (
        <Dialog
            open={ open }
            onClose={ (event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            } }
            fullWidth
            maxWidth="md"
            sx={ {
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            } }
            transitionDuration={ {
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            } }
        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                    <span
                        className='cardColor'
                        style={ {
                            padding: '7px', marginLeft: '-25px', fontWeight: '700',
                            backgroundColor: "#F4F6F8",
                            color: '#637381'
                        } }
                    >
                        &nbsp;&nbsp; Equipments List Create &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={ onClose }>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>

                    <Box
                        mt={ 1 }
                        rowGap={ 2 }
                        gap={ 2 }
                        display="grid"
                        gridTemplateColumns={ {
                            xs: 'repeat(2, 2fr)',
                        } }
                    >
                        <RHFTextField name="CSI_code" label="CSI Code" type='number' />
                        <RHFTextField name="equipment_code" label="Equipments Code" />
                        <RHFTextField name="name" label="Name" />
                        <RHFTextField name="quantity" label="Quanitity" type='number' />
                        <RHFTextField name="unit" label="Unit" type='number' />
                        <RHFTextField name="unit_price" label="Unit price" type='number' />
                        <RHFTextField name="cost_type" label="Cost Type" type='number' />
                        <RHFTextField name="operating_cost" label="operating Cost" type='number' />
                        <RHFTextField name="rental_cost" label="Rental Cost" type='number' />
                        <RHFTextField name="own_cost" label="Own Cost" type='number' />
                        <RHFTextField name="odometer_reading" label="Odometer Reading" type='number' />
                        <RHFTextField name="serial_number" label="operating Cost" type='number' />
                        <RHFTextField name="hours" label="Hours" type='number' />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={ onClose }>
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        className='dark-button'
                        loading={ isSubmitting }
                    >
                        Create
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog >
    );
};